import {
  AppMessageType,
  type IncomingAppMessage,
  type MemberJoinedClearedMessage,
  type MemberJoinedMessage
} from '@/types/appMessage';

export const isMemberJoinedMessage = (
  message: IncomingAppMessage
): message is MemberJoinedMessage => message.type === AppMessageType.MEMBER_JOINED;

export const isMemberJoinedClearedMessage = (
  message: IncomingAppMessage
): message is MemberJoinedClearedMessage => message.type === AppMessageType.MEMBER_JOINED_CLEARED;
